import KUSPIT_CUSTOMER_DOCUMENT_MAGIC_LINK_TYPES from './magic-link/types';

export default {
  ...KUSPIT_CUSTOMER_DOCUMENT_MAGIC_LINK_TYPES,
};
